import { useEffect, useRef } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOT = process.env.REACT_APP_ADSENSE_SLOT;

export function AdSlot({ testId, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!CLIENT || !SLOT || !ref.current || ref.current.dataset.loaded) return;
    ref.current.dataset.loaded = "1";
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch { /* ad blocked */ }
  }, []);
  if (!CLIENT || !SLOT) return null;
  return (
    <div data-testid={testId} className={`col-span-full overflow-hidden rounded-2xl border border-white/5 bg-[#173742]/50 px-3 pb-3 pt-1.5 ${className}`}>
      <p className="mb-1 text-[10px] uppercase tracking-[0.2em] text-slate-500">Advertisement</p>
      <ins ref={ref} className="adsbygoogle block min-h-[90px]" style={{ display: "block" }} data-ad-client={CLIENT} data-ad-slot={SLOT} data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
}

export const withAds = (items, render, every = 8) =>
  items.flatMap((l, i) => {
    const el = render(l, i);
    return (i + 1) % every === 0 && i < items.length - 1 ? [el, <AdSlot key={`ad-${i}`} testId={`ad-slot-${i}`} />] : [el];
  });
